import { BACKGROUND_TASK_URL } from 'consts/api';
import services from 'services';
import querystring from 'query-string';

class BackgroundProcessService {
  resume(body) {
    return services.post(
      `${BACKGROUND_TASK_URL}/resumeFromMaintenance?${querystring.stringify(body)}`
    );
  }

  pause(body) {
    return services.post(
      `${BACKGROUND_TASK_URL}/pauseForMaintenance?${querystring.stringify(body)}`
    );
  }

  search(body, configs) {
    return services.post(`${BACKGROUND_TASK_URL}/search`, body, configs);
  }

  download(taskId) {
    const auth = services.getLocalStorage();
    const sessionId = auth?.jwt;
    return services.get(
      `${BACKGROUND_TASK_URL}/download-result-file?taskId=${taskId}&sessionId=${sessionId}`
    );
  }

  loadTaskType() {
    return services.get(`${BACKGROUND_TASK_URL}/loadTaskEnum`);
  }

  stopBackgroundTasks(body = [123], configs) {
    return services.post(`${BACKGROUND_TASK_URL}/stopBackgroundTasks`, body, configs);
  }

  getBackgroundProcessEnums(configs) {
    return services.get(`${BACKGROUND_TASK_URL}/enums`, configs);
  }

  getBadDidsOfTask(taskId, configs) {
    return services.get(`${BACKGROUND_TASK_URL}/badDids/${taskId}`, configs);
  }
}

export default new BackgroundProcessService();
